module.exports = __webpack_public_path__ + "static/media/profil.e6c6c6ab.jpg";